// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__dd+Oh","others-header__buttons":"Header_others-header__buttons__bf8pO"};